import { render } from "./BaseSubItemCard.vue?vue&type=template&id=61c5313f"
import script from "./BaseSubItemCard.vue?vue&type=script&lang=js"
export * from "./BaseSubItemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__